// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3yj7S","header":"Messages_header__1SQ_s"};